import {eGENA_ProblemKategorie} from './ProblemKategorieABCDE'

/** Items können zu Gruppen zusammengefasst werden. So eine Gruppe besteht aus ihrem Namen und
 *  den Problemkategorien (ABCDE).
 */
export class eGENA_ItemGroup extends eGENA_ProblemKategorie {
	public name : string;

	constructor(name : string, vorlage : eGENA_ProblemKategorie | undefined) {
		super(vorlage);
		this.name = name;
	}
}



// WEBPACK FOOTER //
// ./src/visionet/ItemGroup.ts